// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-button {\n    width: 185px;\n    height: 48px;\n}", "",{"version":3,"sources":["webpack://./src/components/Frame/styles/RegionButton.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".region-button {\n    width: 185px;\n    height: 48px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
